import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

/**
 * Switch to apply external BXGY discount on subscription
 * Binds to applyExternalBXGYDiscountOnSubscription form field
 */
export const ApplyExternalBXGYDiscountOnSubscriptionSwitch = () => {
	const { t } = useTranslation(['stores', 'common'])
	const { control } = useFormContext<{ applyExternalBXGYDiscountOnSubscription: boolean }>()

	return (
		<div className="flex items-center justify-between">
			<div className="space-y-1">
				<Label>
					{t('form.applyExternalBXGYDiscountOnSubscription')}
				</Label>
				<p className="text-xs text-gray-500">
					{t('form.applyExternalBXGYDiscountOnSubscriptionDescription')}
				</p>
			</div>
			<Controller
				name="applyExternalBXGYDiscountOnSubscription"
				control={control}
				render={({ field: { value, onChange } }) => (
					<Switch checked={value} onCheckedChange={onChange} />
				)}
			/>
		</div>
	)
}
